import { TighteningMethod } from '../../enums/tightening-method.enum';

export class GeneralInput {
    boltQuantity: number;
    breakout: boolean;
    lubricantMode: string;
    jointConfiguration: string;
    misalignmentFactor: number;
    percentageCover: string;
    sourService: string;
    tighteningMethod: TighteningMethod;
    tighteningSpecification: string;
    tighteningSpecificationInput: string;
    washerThickness: number;
    loadLossMethod: string;
    boltType: number;
    threadType: string;
}
